import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=de48e7bc&scoped=true&"
import script from "./Template.vue?vue&type=script&lang=ts&"
export * from "./Template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de48e7bc",
  null
  
)

export default component.exports